// Registers src/service-worker.js (production builds only). Trimmed from the
// CRA PWA template: no localhost special-casing, one onUpdate callback.
export function register(config) {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return; // CDN-hosted build: no SW

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // a new build took over the caches; the page still runs the old one
              if (config && config.onUpdate) config.onUpdate(registration);
            }
          };
        };
      })
      .catch((error) => {
        console.error("service worker registration failed:", error);
      });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
  }
}
